module.exports = __webpack_public_path__ + "static/images/d9424b51a81e043aac4b86b471d430e5.webp";